import editorials from "../../data/Editorials.json";
import chapters from "../../data/Chapters.json";

import React from "react";
import "../../styles/Articles.css";
import { useState, useEffect } from "react";

const EditorialsAndChapters = () => {
  const [editorialsData, setEditorials] = useState({ editorials: [] });
  const [chaptersData, setChapters] = useState({ chapters: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setEditorials(editorials);
      setChapters(chapters);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!editorialsData || !chaptersData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Journal Editorials</h2>
      <div className="articles">
        <ol>
          {editorialsData.editorials.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
      <h2>Chapters</h2>
      <div className="articles">
        <ol>
          {chaptersData.chapters.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default EditorialsAndChapters;
